module.exports = __webpack_public_path__ + "img/domain-driven-design.dd81198f.png";